module.exports = __webpack_public_path__ + "img/materials_education_1.f9dc931a.png";